// Mapping of card brands that are returned from the API layer
export const CARD_BRANDS = {
  CHINA_UNION_PAY: 'CHINA_UNION_PAY',
};

// Mapping of card confirmation methods that are returned from the API layer
export const CARD_CONFIRMATION_METHODS = {
  ONE_TIME_PASSWORD_CONFIRMATION: 'ONE_TIME_PASSWORD_CONFIRMATION',
} as const;
